export const TIMEZONE = {
  UTC: "UTC",
  JST: "JST",
  LT: "LT",
};